import { Pipe, PipeTransform } from '@angular/core'
import { CourtSystemUser } from '@ftr/contracts/api/court-system'
import { User } from '@ftr/contracts/api/user'

@Pipe({ name: 'ftrUserName', standalone: true })
export class UserNamePipe implements PipeTransform {
  transform(user: User | CourtSystemUser): string {
    return user.givenName ? `${user.givenName} ${user.familyName}` : user.email
  }
}
